import addClickHandler from 'mex_components/app/scripts/events/addClickHandler';
import addStartupScript from 'mex_components/app/scripts/events/addStartupScript';
import dispatchCustomEvent from 'mex_components/app/scripts/events/dispatchCustomEvent';
import forEachSelector from 'mex_components/app/scripts/elements/forEachSelector';
import toggleClass from 'mex_components/app/scripts/elements/toggleClass';
import buyboxLinkTracker from './buybox_link_tracker';
import setupRadioButtonTracking from './radio_button_tracking';
import picklistSelectionTracking from './picklist_selection_tracking';
import pickListButtonTracker from './pick_list_button_tracking';

const WRAPPER_SELECTOR = '.buy-box-subscription-filter';
const RADIO_BUTTON_INPUT_SELECTOR =
  '.buy-box-subscription-filter .radio-button input';
let wrapper;
let radioButtons;

/**
 * Returns the value of the checked radio button input
 */
const getRadioButtonValue = () => {
  return wrapper.querySelector('.radio-buttons input:checked')?.value;
};

/**
 * Event handler for when the dropdown changes. Expecting payload to
 * include data.value where the value is comma-separated string of item ids
 */
const handleDropdownChange = ({ detail: { data } }) => {
  if (!data || !data.value) return;

  wrapper.dataset.itemIds = data.value;
  // show the radio buttons
  toggleClass(radioButtons, 'hidden', false);
  sendFilterEvent();
};

/**
 * Event handler for when the radio button selection changes. Expecting
 * a checked radio input with a falsey value or a subscription id
 */
const handleRadioButtonClick = () => {
  wrapper.dataset.subscriptionId = getRadioButtonValue();
  sendFilterEvent();
};

/**
 * Sends a filter event so listeners can fetch and render items
 */
const sendFilterEvent = () => {
  const itemIds = wrapper.dataset.itemIds;
  const subscriptionId = wrapper.dataset.subscriptionId;
  if (!itemIds) return;

  dispatchCustomEvent(document, 'subscriptionFilter.change', {
    data: { itemIds, subscriptionId },
  });
};

const setupEventHandlers = () => {
  document.addEventListener('dropdown.change', handleDropdownChange);
  picklistSelectionTracking();
  pickListButtonTracker();
  forEachSelector(RADIO_BUTTON_INPUT_SELECTOR, (el) => {
    buyboxLinkTracker(el);
    // adds radio button clicks to GA360 / GTM
    setupRadioButtonTracking(el);
    addClickHandler(el, handleRadioButtonClick);
  });
};

export function setup() {
  wrapper = document.querySelector(WRAPPER_SELECTOR);
  // return quickly if subscription filter doesn't exist on page load
  if (!wrapper) return;
  radioButtons = wrapper.querySelector('.radio-buttons');
  // return quickly if we don't have a subscription filter
  if (!wrapper || !radioButtons) return;

  // set initial subscriptionId
  wrapper.dataset.subscriptionId = getRadioButtonValue();

  setupEventHandlers();
}

addStartupScript(setup);
